<template>
  <div>
    <Top></Top>
    <!-- <ul class="nav">
      <li @click="index = 1">
        <a href="#gjfy" class="br" :class="{ bgc: index == 1 }">
          国際送料
          <br />見積ツール
        </a>
      </li>
      <li @click="index = 2">
        <a href="#gjys" :class="{ bgc: index == 2 }">簡易比較表</a>
      </li>
      <li @click="index = 3">
        <a href="#ems" class="br" :class="{ bgc: index == 3 }">
          ＥＭＳ
          <br />航空便
        </a>
      </li>
      <li @click="index = 4">
        <a href="#ocs" :class="{ bgc: index == 4 }">ＯＣＳ</a>
      </li>
      <li @click="index = 5">
        <a href="#wzk" :class="{ bgc: index == 5 }">無在庫便</a>
      </li>
      <li @click="index = 6">
        <a href="#BT" :class="{ bgc: index == 6 }">電子特殊便</a>
      </li>
      <li @click="index = 7">
        <a href="#EMS" :class="{ bgc: index == 7 }">ＥＭＳ船便</a>
      </li>
      <li @click="index = 8">
        <a href="#dc" :class="{ bgc: index == 8 }">DC船便</a>
      </li>
      <li @click="index = 9">
        <a href="#gs" :class="{ bgc: index == 9 }">高速船便</a>
      </li>
      <li @click="index = 10">
        <a href="#fba" class="br" :class="{ bgc: index == 10 }">
          ＦＢＡ
          <br />新幹線
        </a>
      </li>
      <li @click="index = 11">
        <a href="#dqb" :class="{ bgc: index == 11 }">コンテナ</a>
      </li>
      <li @click="index = 12">
        <a href="#fed" class="br" :class="{ bgc: index == 12 }">
          その他海
          <br />外対応
        </a>
      </li>
    </ul> -->
    <div class="main">
      <h2 id="gjfy" ref="gjfy">国際送料</h2>
      <!-- 费用计算 -->

      <!-- <h3 id="gjys" ref="gjys">国際輸送簡易比較表</h3> -->
      <!-- 国际运输 -->
      <!-- <div class="gjys">
        <div class="title">
          <span>項目</span>
          <div class="hangkong">
            <h6>
              航
              <i></i> 空 <i></i> 便
            </h6>
            <ul>
              <li>EMS</li>
              <li>OCS</li>
              <li>無在庫便</li>
              <li>電子特殊便</li>
            </ul>
          </div>
          <div class="chuangbian">
            <h6>
              船
              <i></i>
              <i></i>
              <i></i>便
            </h6>
            <ul>
              <li>EMS</li>
              <li>OCS</li>
              <li>無在庫便</li>
              <li>電子特殊便</li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span>FBA納品</span>
          <div class="hk">
            <ul>
              <li>×</li>
              <li>○</li>
              <li>×</li>
              <li>○</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li>×</li>
              <li>○</li>
              <li>○</li>
              <li>○</li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span>電池・磁石</span>
          <div class="hk">
            <ul>
              <li>×</li>
              <li>×</li>
              <li>×</li>
              <li>○</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li>○</li>
              <li>○</li>
              <li>○</li>
              <li>○</li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span>液体 含む</span>
          <div class="hk">
            <ul>
              <li>×</li>
              <li>×</li>
              <li>×</li>
              <li>×</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li>○</li>
              <li>×</li>
              <li>×</li>
              <li>×</li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span>重量制限</span>
          <div class="hk">
            <ul>
              <li>～30kg/箱</li>
              <li>無制限</li>
              <li>5kg迄</li>
              <li>～40kg/箱</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li>～30kg/箱</li>
              <li>無制限</li>
              <li>
                1m
                <sup>3</sup> 以上
              </li>
              <li>~50kg/箱</li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span>同梱制限</span>
          <div class="hk">
            <ul>
              <li>無</li>
              <li>無</li>
              <li>無</li>
              <li>無</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li>無</li>
              <li>2種類迄</li>
              <li>無</li>
              <li>2種類迄</li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span>納期(目安)</span>
          <div class="hk">
            <ul>
              <li>4日～</li>
              <li>3日～</li>
              <li>4日～</li>
              <li>5日～</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li>3週間～</li>
              <li>8日～</li>
              <li>10日～</li>
              <li>12日～</li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span>配送会社</span>
          <div class="hk">
            <ul>
              <li>日本郵便</li>
              <li>佐川急便</li>
              <li>ヤマト</li>
              <li>佐川急便</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li>日本郵便</li>
              <li>佐川急便</li>
              <li>佐川急便</li>
              <li>佐川急便</li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span>容積重量値</span>
          <div class="hk">
            <ul>
              <li>6000</li>
              <li>6000</li>
              <li>6000</li>
              <li>6000</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li>無</li>
              <li>5000</li>
              <li>無</li>
              <li>5000</li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span>最安価格</span>
          <div class="hk">
            <ul>
              <li>16元/kg</li>
              <li>15元/kg</li>
              <li>下記参照</li>
              <li>25元/kg</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li>下記参照</li>
              <li>8.5元/kg</li>
              <li>
                無900元/m
                <sup>3</sup>
              </li>
              <li>8.5元/kg</li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span>備考</span>
          <div class="hk">
            <ul>
              <li>月曜日～金曜日のみ運行</li>
              <li></li>
              <li>日本到着後</li>
              <li>沖縄・北海道 ・鹿児島</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li></li>
              <li>週2回の集荷発送</li>
              <li>重量物最適</li>
              <li></li>
            </ul>
          </div>
        </div>
        <div class="content">
          <span></span>
          <div class="hk">
            <ul>
              <li></li>
              <li></li>
              <li>追跡可</li>
              <li>遠隔地費用あり</li>
            </ul>
          </div>
          <div class="cb">
            <ul>
              <li></li>
              <li>集荷発送</li>
              <li>週2回の 集荷発送</li>
              <li>週2回の 集荷発送</li>
            </ul>
          </div>
        </div>
        <div class="txt">
          <p>※運賃は下記の送料表をご覧の上、配送方法をお選び下さい。</p>
          <p>※各運送会社の追跡サイトは弊社トップページに記載されます。</p>
          <p>
            ※最安価格は発送重量によって変わりますので、あくまで参考（最安値）となります。
          </p>
          <p>
            ※その他、コンテナ混載便や貸切コンテナ便もあります。詳しく下記でご確認下さい。
          </p>
          <h6>商品発送の注意事項</h6>
          <p>※特に指定が無い場合は、20kg以上はOCSにて発送させて頂きます。</p>
          <p>
            ※全配送会社、実際重量と容積換算どちらのか重い方の計算となります。
          </p>
          <p>
            ※容積換算重量算出の場合は、いずれも計算値6000で計算致します。（高速船便、FedEx
            5000 OCS 8000で計算）
          </p>
          <p>
            容積換算式：段ボール箱外寸（60cm×40cm×50cm）、容積重量は（60×40×50）÷定数（6000の場合）＝20kgになります。
          </p>
          <p>
            ※関税、輸入消費税が発生する場合があります。金額は日本税関を通過するまで解りません。関税が発生した場合、着払い又は後日請求になります。
          </p>
        </div>
      </div> -->

      <!-- 无在库便 -->
      <div id="wzk" class="table" ref="wzk">
        <div class="head">
          <div class="border-left2"></div>
          <div class="border-right2"></div>
          <h3>無在庫便</h3>
        </div>
        <ol>
          <li>重量</li>
          <li v-for="(item, index) in freight" :key="index">
            {{ item.label }}
          </li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li v-for="(item, index) in freight" :key="index">
            {{ item.value }}
          </li>
        </ol>
        <div class="txt">
          <p>※ 代行手数料：商品1着につき１５元（詳細検品費用込み）</p>
          <p>※ 納期（目安）4日～ 弊社倉～発送先迄</p>
          <p>※ 発送ご依頼主の名前や会社名（店舗名）を任意に記載できます</p>
          <!-- <p>※ １箱積商品代金10000円まで</p> -->
          <p>※ 沖縄に配送する場合は、70元／箱の配送料をプラス</p>
          <p>
            ※ 返送手数料：2000円
            （受け取り拒否、記入住所不備や表札なし住所不明などにより初回配達から５日経過し、返送される場合
          </p>
          <p>梱包注意：</p>
          <p>※ 縦＋横＋高さ合計90cm以内。</p>
          <!-- <p>※ 容積重量換算(6000)</p> -->
          <p>※ 梱包重量 ５kg迄</p>
          <p>最終更新日：２０２４年７月１日</p>
        </div>
      </div>
      <!-- post便 -->
      <div id="wzk" class="table" ref="wzk">
        <div class="head">
          <div class="border-left2"></div>
          <div class="border-right2"></div>
          <h3>post便</h3>
        </div>
        <ol>
          <li style="flex:0.2">重量</li>
          <li>0.001-0.5kg </li>
          <li>0.501-1kg</li>

        </ol>
        <ol>
          <li style="flex:0.2">送料(元)</li>
          <li>
            35
          </li>
          <li>
            45
          </li>
        </ol>
        <div class="txt">
          <p>※ 納期（目安）4日～ 弊社倉～発送先迄</p>
          <p>※ 発送ご依頼主の名前や会社名（店舗名）を任意に記載できます</p>
          <p>※ 沖縄に配送する場合は、70元／回の配送料をプラス</p>
          <!-- <p>※ １箱積商品代金10000円まで</p> -->
          <!-- <p>※ 北海道、沖縄に配送する場合は、70元／箱の配送料をプラス</p> -->
          <p>
            ※ 返送手数料：2000円 （受け取り拒否、記入住所不備や表札なし住所不明などにより初回配達から５日経過し、返送される場合
          </p>
          <p>梱包注意：</p>
          <p>※ 縦 23-31cm以内</p>
          <p style="text-indent: 1.2em;">横 11-22cm以内</p>
          <p style="text-indent: 1.2em;"> 高さ 2.5cm迄</p>
          <p>※ 梱包最大重量 1kg迄</p>
        </div>
      </div>
      <!-- EMS -->
      <div id="ems" class="table" ref="ems">

        <div class="head">
          <div class="border-left2" style="width: 350px;"></div>
          <div class="border-right2" style="width: 350px;"></div>
          <h3> ゆうパケットパフ　EMS便</h3>
        </div>
        <ol>
          <li>重量</li>
          <li v-for="(item, index) in emsFreight" :key="index">
            {{ item.label }}
          </li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li v-for="(item, index) in emsFreight" :key="index">
            {{ item.value }}
          </li>
        </ol>
        <div class="txt">
          <p>
            ※ 納期（目安）4日～ 弊社倉～発送先迄
          </p>
          <p>※ 発送ご依頼主の名前や会社名（店舗名）を任意に記載できます</p>
          <p>※ 遠隔地のプラス配送料がかかりません</p>
          <p>※ 廃棄処分手数料：30元 （記入住所不備や表札なし住所不明などにより配達できなく、国際運送会社日本側の倉庫に返送される場合廃棄処分になります。）</p>
          <p>※国際発送後配送先の変更や転送ができません</p>
          <p>梱包注意：</p>
          <p>※ 22*31cmの専用袋梱包</p>
          <p>※ 梱包最大重量 3kg迄</p>

        </div>
      </div>
      <!-- OCS -->
      <!-- <div id="ocs" class="table" ref="ocs">
        <div class="head">
          <div class="border-left1"></div>
          <div class="border-right1"></div>
          <img src="../../assets/img/ocs (1).png" alt />
        </div>
        <div class="txt1">
          <p>
            日本の航空会社ANAの資本参加により、ジャパンクウォリティーが実現されたFBA直納ができる輸送会社です。
          </p>
          <p>
            日本国内配送は、法人向けには、OCSが、個人向けには、佐川便で配達致します。
          </p>
          <p>
            荷物通関がOCSから代行致します。関税が発生した場合は、OCS会社から請求書を発行して、
          </p>
          <p>OCS会社にお支払う手順になります。</p>
        </div>
        <ol>
          <li>重量</li>
          <li>0 ~ 0.5kg</li>
          <li>1kg</li>
          <li>2kg</li>
          <li>3kg</li>
          <li>4kg</li>
          <li>5kg</li>
          <li>6kg</li>
          <li>7kg</li>
          <li>8kg</li>
          <li>9kg</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li>95</li>
          <li>110</li>
          <li>140</li>
          <li>170</li>
          <li>220</li>
          <li>230</li>
          <li>260</li>
          <li>290</li>
          <li>320</li>
          <li>350</li>
        </ol>
        <ol>
          <li>重量</li>
          <li>10kg</li>
          <li>11kg</li>
          <li>12kg</li>
          <li>13kg</li>
          <li>14kg</li>
          <li>15kg</li>
          <li>16kg</li>
          <li>17kg</li>
          <li>18kg</li>
          <li>19kg</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li>380</li>
          <li>410</li>
          <li>440</li>
          <li>470</li>
          <li>500</li>
          <li>530</li>
          <li>560</li>
          <li>590</li>
          <li>620</li>
          <li>650</li>
        </ol>
        <ol>
          <li>重量</li>
          <li class="flex5">20kg</li>
          <li class="flex5">20kg以上</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li class="flex5">680</li>
          <li class="flex5">24元/kg</li>
        </ol>
        <div class="txt">
          <p>※ 納期（目安）３日～</p>
          <p>※ 一番お勧めする安心・安全なルートです。</p>

          <p>※ 体積重量換算定数は6000</p>
        </div>
      </div> -->
      <!-- BT特殊便（磁石・電池商品） -->
      <!-- <div id="BT" class="table" ref="BT">
        <div class="head">
          <div class="border-left2" style="width: 280px"></div>
          <div class="border-right2" style="width: 280px"></div>
          <h3>BT特殊便（磁石・電池商品）</h3>
        </div>
        <ol>
          <li>重量</li>
          <li>10kg未満</li>
          <li>11-20kg</li>
          <li>21-100kg</li>
          <li>101kg～</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li>180元/kg＋以後1kg毎40元</li>
          <li>28元/kg</li>
          <li>26元/kg</li>
          <li>25元/kg</li>
        </ol>
        <div class="txt">
          <p>※ 納期（目安）3日～</p>
          <p>※ 沖縄・北海道・鹿児島まで50キロ以下+150元、</p>
          <p>50キロ以上は+3元/キロとなります。</p>
          <p>※ Amazon FBA倉庫納入可</p>
          <p>※ バッテリそのものだけの発送は別途相談してください。</p>
          <p>※ ※容積換算体積/6000で決済されます。</p>
          <p>例） 段ボール箱サイズ 60*50*40 実際重量10kgの場合</p>
          <p>60*50*40/6000＝20</p>
          <p>20kgが実際の決済重量になります。</p>
        </div>
      </div> -->
      <!-- EMS船便
      <div id="EMS" class="table" ref="EMS">
        <div class="head">
          <div class="border-left2"></div>
          <div class="border-right2"></div>
          <h3>EMS船便</h3>
        </div>
        <ol>
          <li>重量</li>
          <li>1kg</li>
          <li>2kg</li>
          <li>3kg</li>
          <li>4kg</li>
          <li>5kg</li>
          <li>6kg</li>
          <li>7kg</li>
          <li>8kg</li>
          <li>9kg</li>
          <li>10kg</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li>162</li>
          <li>130</li>
          <li>143</li>
          <li>157</li>
          <li>170</li>
          <li>183</li>
          <li>197</li>
          <li>210</li>
          <li>224</li>
          <li>237</li>
        </ol>
        <ol>
          <li>重量</li>
          <li>11kg</li>
          <li>12kg</li>
          <li>13kg</li>
          <li>14kg</li>
          <li>15kg</li>
          <li>16kg</li>
          <li>17kg</li>
          <li>18kg</li>
          <li>19kg</li>
          <li>20kg</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li>250</li>
          <li>264</li>
          <li>277</li>
          <li>291</li>
          <li>304</li>
          <li>317</li>
          <li>331</li>
          <li>344</li>
          <li>358</li>
          <li>371</li>
        </ol>
        <ol>
          <li>重量</li>
          <li>21kg</li>
          <li>22kg</li>
          <li>23kg</li>
          <li>24kg</li>
          <li>25kg</li>
          <li>26kg</li>
          <li>27kg</li>
          <li>28kg</li>
          <li>29kg</li>
          <li>30kg</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li>384</li>
          <li>398</li>
          <li>411</li>
          <li>425</li>
          <li>438</li>
          <li>451</li>
          <li>465</li>
          <li>478</li>
          <li>493</li>
          <li>505</li>
        </ol>
        <div class="txt">
          <p>※ 納期（目安）20日～30日</p>
          <p>※ Amazon FBA倉庫納入不可</p>
          <p>※ 30kg以内で、日数をかかってもいい場合有効な発送手段です。</p>
          <p>
            ※
            航空便搭載ができない商品（電池、磁石、液体が入っている商品等）にお勧めです。
          </p>
          <p>※ 31kgは2個口になります。1箱単位の計算になります。</p>
          <p>※ 1kg未満は切り上げ換算になります。</p>
        </div>
      </div> -->
      <!-- DC船便 -->
      <!-- <div id="dc" class="table" ref="dc">
        <div class="head">
          <div class="border-left2" style="width: 200px"></div>
          <div class="border-right2" style="width: 200px"></div>
          <h3>DC船便 FBA納品可能 １０－２０日間到着</h3>
        </div>
        <ol>
          <li>重量</li>
          <li>1~50kg</li>
          <li>51~300kg</li>
          <li>301~500kg</li>
          <li>501~1999kg</li>
          <li>2000kg~</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li>12元/kg</li>
          <li>10元/kg</li>
          <li>9.5元/kg</li>
          <li>9元/kg</li>
          <li>8.5元/kg</li>
        </ol>
        <div class="txt">
          <p>※ 週に3便運航、通関手数料1500円/件 別途</p>
          <p>※ 箱サイズ ３辺合計180ｃｍ以内、１箱重量50kg以内</p>
          <p>※ 食品衛生法に関わる商品、６歳以下適用玩具は発送不可。</p>
          <p>※磁性 電池商品は発送可</p>
          <p>※ 沖縄、北海度、離島は +3元/kgの転送料が別途掛かります。</p>
          <p>※ 容積重量 5000</p>
        </div>
      </div> -->
      <!-- 高速船便 -->
      <!-- <div id="gs" class="table" ref="gs">
        <div class="head">
          <div class="border-left2" style="width: 230px"></div>
          <div class="border-right2" style="width: 230px"></div>
          <h3>高速船便（新規ルート）FBA納品可能</h3>
        </div>
        <ol>
          <li>重量</li>
          <li>1~300kg</li>
          <li>301~500kg</li>
          <li>501~1000kg</li>
          <li>1001~2000kg</li>
          <li>2001kg~~</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li>12元/kg</li>
          <li>11元/kg</li>
          <li>10元/kg</li>
          <li>9元/kg</li>
          <li>8元/kg</li>
        </ol>
        <div class="txt">
          <p>※ 水曜日午前中で出荷依頼締切⇒木曜日出荷⇒１週間到着</p>
          <p>※ １箱に最大２種類の商品までの制限あり</p>
          <p>※ Amazon FBA倉庫納入可</p>
          <p>※ 内蔵電池·磁石·発送可能です。</p>
          <p>※ 液体・武器形状のもの全般発送不可。</p>
          <p>※ 沖縄·北海道·離島は１箱３０００円の転送料が別途掛かります。</p>
          <p>※ 容積換算重量は５０００で計算されます。</p>
        </div>
      </div> -->
      <!-- FBA直送専用船便 -->
      <!-- <div id="fba" class="table" ref="fba">
        <div class="head">
          <div class="border-left2" style="width: 350px"></div>
          <div class="border-right2" style="width: 350px"></div>
          <h3>FBA直送専用船便</h3>
        </div>
        <ol>
          <li>FBA 物流センター</li>
          <li>1～5/m³</li>
          <li>6～10/m³</li>
          <li>11～15/m³</li>
          <li>15/m³以上</li>
        </ol>
        <ol class="ol">
          <li>
            <div>NRT1（市川FC)</div>
            <div>NRT2（八千代FC)</div>
            <div>NRT5（川越FC)</div>
            <div>HND3（川島FC）</div>
            <div>FSZ1（小田原FC)</div>
            <div>KIX1（堺FC)</div>
            <div>KIX2（大東FC)</div>
            <div>NGO2（多治見FC)</div>
          </li>
          <li>1300元/m³</li>
          <li>1200元/m³</li>
          <li>1100元/m³</li>
          <li>900元/m³</li>
        </ol>
        <ol>
          <li>HSG1（鳥栖FC)</li>
          <li>1700元/m³</li>
          <li>1600元/m³</li>
          <li>1500元/m³</li>
          <li>1300元/m³</li>
        </ol>
        <div class="txt">
          <h6>※上記表の数値は1立方メートルあたりの単価になります。</h6>
          <h6>（１/m3：イチエムスリー）</h6>
          <h6>※１立方メートル以下は切り上げになります。（例）1.1/m3⇒２/m3</h6>
          <p style="margin-top: 30px">★AmazonFBA以外への発送は出来ません。</p>
          <p>
            ★通関費用、FBA倉庫迄の配送料込みの価格です。関税等は別途請求です。
          </p>
          <p>★内蔵電池・磁石商品発送可能です。</p>
          <p>★液体・武器形状のもの全般発送不可。</p>
          <p>
            ★玩具類は、「対象は年齢７歳以上の子供用」というラベルを貼る事で可能
          </p>
          <p style="margin-top: 30px">★出荷スケジュール（週２回集荷）</p>
          <h6>①毎週火曜日出荷⇒翌木曜日迄にFBAセンター納品</h6>
          <h6>②毎週木曜日出荷⇒翌金曜日迄にFBAセンター納品</h6>
          <h6>※上記配送スケジュールは目安となります。遅れる場合もあります。</h6>
          <p style="margin-top: 30px">★集荷費用別途必要</p>
          <h6>
            １/m3あたり50元が別途かかります。１/m3未満の場合は1/m3として計算。
          </h6>
          <h6>小数点以下切り上げとなります。</h6>
        </div>
      </div> -->
      <!-- コンテナ　　20フィート/40フィート貸切便 -->
      <!-- <div id="dqb" class="table" ref="dqb">
        <div class="head">
          <div class="border-left2" style="width: 200px"></div>
          <div class="border-right2" style="width: 200px"></div>
          <h3>コンテナ 20フィート/40フィート貸切便</h3>
        </div>
        <div class="bg">
          <img src="../../assets/img/container1.png" alt />
          <img src="../../assets/img/container2.png" alt />
        </div>
        <div class="txt">
          <h6>
            ※コンテナ貸切発送は輸入品目、通関業者によって料金が変わりますので、その都度お問い合わせください。
          </h6>
        </div>
      </div> -->
      <!--fedEx  -->
      <!-- <div id="fed" class="table" ref="fed">
        <div class="head">
          <div class="border-left1" style="top: 120px"></div>
          <div class="border-right1" style="top: 120px"></div>
          <img src="../../assets/img/fed.png" alt />
        </div>
        <h5>米国FBA納品適用</h5>
        <div class="h5">快速便 2日～3日 サーチャージ込み</div>
        <ol>
          <li>重量</li>
          <li>0—0.5 kg</li>
          <li>0.5--20 kg</li>
          <li>21--44kg</li>
          <li>45--100kg</li>
          <li>101以上</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li>132.00元</li>
          <li>132.00元+37.00元/0.5kg</li>
          <li>43.00元/kg</li>
          <li>40.00元/kg</li>
          <li>40.00元/kg</li>
        </ol>
        <div class="txt">
          <p>※容積重量換算値=[縦(cm) x 横(cm) x 高さ(cm) ÷ 5000]</p>
          <p>※以下の荷物は航空便で発送不可となります。</p>
          <p>バッテリー、電池類</p>
          <p>のり、香水などの液体</p>
          <p>磁石、スピーカーなど磁気性があるもの</p>
          <p>ナイフ、爆弾などの武器類、及び武器形状のもの</p>
        </div>
        <div class="h5">エコノミー便 5日～7日 サーチャージ込み</div>
        <ol>
          <li>重量</li>
          <li>0—0.5 kg</li>
          <li>0.5--20 kg</li>
          <li>21--44kg</li>
          <li>45--100kg</li>
          <li>101以上</li>
        </ol>
        <ol>
          <li>送料(元)</li>
          <li>122.00元</li>
          <li>122.00元+32.00元/0.5kg</li>
          <li>41.00元/kg</li>
          <li>39.00元/kg</li>
          <li>39.00元/kg</li>
        </ol>
        <div class="txt">
          <p>※配送先までの送料込み体積重量換算定数は5000</p>
          <p>※関税発生時は後日お支払いとなります。</p>
        </div>
      </div> -->
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
import { freight, emsFreight } from "../../utlis/freight";
export default {
  data() {
    return {
      options: [
        {
          value: "市川FC",
          label: "市川FC",
        },
        {
          value: "八千代FC",
          label: "八千代FC",
        },
        {
          value: "川越FC",
          label: "川越FC",
        },
        {
          value: "川島FC",
          label: "川島FC",
        },
        {
          value: "小田原FC",
          label: "小田原FC",
        },
        {
          value: "堺FC",
          label: "堺FC",
        },
        {
          value: "大東FC",
          label: "大東FC",
        },
        {
          value: "多治見FC",
          label: "多治見FC",
        },
        {
          value: "鳥栖FC",
          label: "鳥栖FC",
        },
      ],
      p: `<div class="cost">
        <div class="input">
          <!-- 重量 -->
          <input
            type="text"
            placeholder="梱包重量"
            v-model="kg"
            oninput="this.value=this.value.replace(/[^\d.]/g,'')"
            @blur="price"
          />
          <button>kg</button>
          <!-- 选择 -->
          <select name id>
            <option value="日本">日本</option>
            <option value="米国">米国</option>
          </select>
          <!-- 长 -->
          <input
            type="text"
            placeholder="縦(cm)"
            v-model="chang"
            oninput="this.value=this.value.replace(/[^\d.]/g,'')"
            @input="getTiji"
          />
          <button>cm</button>
          <span>x</span>
          <!-- 宽 -->
          <input
            type="text"
            placeholder="横(cm)"
            v-model="kuang"
            oninput="this.value=this.value.replace(/[^\d.]/g,'')"
            @input="getTiji"
          />
          <button>cm</button>
          <span>x</span>
          <!-- 高 -->
          <input
            type="text"
            placeholder="高さ(cm)"
            v-model="gao"
            oninput="this.value=this.value.replace(/[^\d.]/g,'')"
            @input="getTiji"
          />
          <button>cm</button>
          <span>=</span>
          <!-- = -->
          <input
            type="text"
            placeholder="体積"
            oninput="this.value=this.value.replace(/[^\d.]/g,'')"
            v-model="tiji"
          />
          <button>
            m
            <sup>3</sup>
          </button>
        </div>
        <!-- 物流费用 -->
        <!-- <ul>
          <li>
            <img src="../../assets/img/baoguo2.png" alt />
            <h4>EMS</h4>
            <h5>4日～</h5>
            <p>重量の上限 <=30キログラム</p>
            <div class="money">100元</div>
          </li>
          <li>
            <img src="../../assets/img/baoguo2.png" alt />
            <h4>OCS</h4>
            <h5>3日～</h5>
            <p></p>
            <div class="money">100元</div>
          </li>
          <li>
            <img src="../../assets/img/baoguo2.png" alt />
            <h4>ZC便 通常小包</h4>
            <h5>3日～</h5>
            <p>重量の上限 <=30キログラム</p>
            <div class="money">100元</div>
          </li>
          <li>
            <img src="../../assets/img/baoguo2.png" alt />
            <h4>電子特殊便</h4>
            <h5>5日～</h5>
            <p></p>
            <div class="money">100元</div>
          </li>
          <li>
            <img src="../../assets/img/baoguo2.png" alt />
            <h4>EMS船便</h4>
            <h5>3週間～</h5>
            <p>重量の上限 <=30キログラム</p>
            <div class="money">100元</div>
          </li>
          <li>
            <img src="../../assets/img/baoguo2.png" alt />
            <h4>高速船便</h4>
            <h5>8日～</h5>
            <p></p>
            <div class="money">100元</div>
          </li>
          <li>
            <img src="../../assets/img/baoguo2.png" alt />
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <h4>FBA新幹線</h4>
            <h5>4日～</h5>
            <p>重量の上限 <=30キログラム</p>
            <div class="money">100元</div>
          </li>
        </ul> -->
      </div>`,
      value: "市川FC",
      index: 0, // 导航背景色
      kg: "", // 公斤
      chang: "", // 长
      kuang: "", //宽
      gao: "", // 高
      tiji: "", //体积
      emsTotal: "", // ems飞机
      ocsTotal: "", // ocs价格
      freight,
      emsFreight,
    };
  },
  components: {
    Top,
    Foot,
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 滑动
    handleScroll() {
      let scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let gjfy = this.$refs.gjfy.offsetTop - 100; //- this.$refs.gjfy.scrollHeight;
      let gjys = this.$refs.gjys.offsetTop - 100; //- this.$refs.gjys.scrollHeight;
      let ems = this.$refs.ems.offsetTop - 100; //- this.$refs.ems.scrollHeight;
      let ocs = this.$refs.ocs.offsetTop - 100; //- this.$refs.ocs.scrollHeight;
      let wzk = this.$refs.wzk.offsetTop - 100; // - this.$refs.wzk.scrollHeight;
      let BT = this.$refs.BT.offsetTop - 100; // - this.$refs.BT.scrollHeight;
      let EMS = this.$refs.EMS.offsetTop - 100; //- this.$refs.EMS.scrollHeight;
      let dc = this.$refs.dc.offsetTop - 100; //- this.$refs.dc.scrollHeight;
      let gs = this.$refs.gs.offsetTop - 100; //- this.$refs.gs.scrollHeight;
      let fba = this.$refs.fba.offsetTop - 100; // - this.$refs.fba.scrollHeight;
      let dqb = this.$refs.dqb.offsetTop - 100; // - this.$refs.dqb.scrollHeight;
      let fed = this.$refs.fed.offsetTop - 100; //- this.$refs.fed.scrollHeight;
      if (scroll > gjfy && scroll < gjys) {
        this.index = 1;
      } else if (scroll > gjys && scroll < ems) {
        this.index = 2;
      } else if (scroll > ems && scroll < ocs) {
        this.index = 3;
      } else if (scroll > ocs && scroll < wzk) {
        this.index = 4;
      } else if (scroll > wzk && scroll < BT) {
        this.index = 5;
      } else if (scroll > BT && scroll < EMS) {
        this.index = 6;
      } else if (scroll > EMS && scroll < dc) {
        this.index = 7;
      } else if (scroll > dc && scroll < gs) {
        this.index = 8;
      } else if (scroll > gs && scroll < fba) {
        this.index = 9;
      } else if (scroll > fba && scroll < dqb) {
        this.index = 10;
      } else if (scroll > dqb && scroll < fed) {
        this.index = 11;
      } else if (scroll > fed) {
        this.index = 12;
      }
    },
    // 计算体积
    getTiji() {
      if (this.chang != "" && this.kuang != "" && this.gao != "") {
        this.tiji = (this.chang * this.kuang * this.gao) / 1000000;
      }
    },
    // 计算价格
    price() {
      //   if (this.kg > 100) {
      //     this.ocsTotal = this.kg * 15;
      //   } else if (this.kg > 50) {
      //     this.ocsTotal = this.kg * 17;
      //   } else if (this.kg > 20) {
      //     this.ocsTotal = this.kg * 18;
      //   }
    },
  },
};
</script>
<style lang='scss' scoped>
.nav {
  position: fixed;
  top: 0px;
  left: 0;
  z-index: 99;

  li {
    border-bottom: 1px solid #fff;
    background: #7a6e6e;
    text-align: center;

    a {
      display: block;
      width: 92px;
      height: 60px;
      color: #fff;
      font-size: 14px;
      line-height: 60px;
    }

    .br {
      line-height: 30px;
    }
  }
}

.bgc {
  background: #f3c622 !important;
}

.main {
  width: 1200px;
  margin: 0 auto 150px;

  h2 {
    text-align: center;
    font-size: 48px;
    font-weight: 700;
    margin: 120px 0 80px;
  }

  .cost {
    overflow: hidden;

    .input {
      width: 1200px;
      overflow: hidden;
      height: 100px;

      input {
        float: left;
        height: 56px;
        width: 100px;
        border: 2px solid #f3c622;
        padding-left: 12px;
        font-size: 16px;
      }

      button {
        float: left;
        width: 56px;
        height: 60px;
        background: #f3c622;
        font-size: 22px;
        color: #fff;
        font-weight: 700;
        //   vertical-align: middle;
      }

      select {
        width: 195px;
        float: left;
        height: 60px;
        border: 2px solid #f3c622;
        font-size: 20px;
        margin: 0 40px 0 40px;
      }

      span {
        float: left;
        line-height: 60px;
        margin: 0 3px;
      }
    }

    ul {
      margin-top: 40px;

      li {
        width: 285px;
        height: 320px;
        padding-top: 40px;
        border: 1px solid #999;
        float: left;
        margin: 0 10px 10px 0;
        border-radius: 5px;
        text-align: center;

        h4 {
          margin: 10px 0 12px;
          font-size: 18px;
          font-weight: 700;
        }

        h5 {
          color: #333;
        }

        p {
          margin: 10px 0 20px;
          font-size: 10px;
          height: 20px;
        }

        .money {
          font-size: 16px;
          font-weight: 700;
          color: #f3c622;
        }
      }
    }
  }

  h3 {
    text-align: center;
    font-size: 36px;
    margin: 120px 0 80px;
  }

  .gjys {
    .title {
      display: flex;
      height: 77px;
      text-align: center;
      color: #fff;

      span {
        flex: 1;
        background: #a7a7a7;
        line-height: 110px;
      }

      .hangkong {
        flex: 4;
        background: #f3c622;
        border-right: 1px solid #fff;
      }

      .chuangbian {
        flex: 4;
        background: #4e75d2;
      }

      h6 {
        font-size: 18px;
        line-height: 40px;

        i {
          margin: 0 5px;
        }
      }

      ul {
        display: flex;

        :nth-child(1) {
          flex: 1.3;
        }

        :nth-last-child(1) {
          flex: 1.3;
        }

        li {
          float: left;
          flex: 1;
          line-height: 30px;
          text-align: center;
        }
      }
    }

    .content:nth-of-type(even) {
      background-color: #eee;
    }

    .content {
      display: flex;
      height: 37px;
      text-align: center;
      border-bottom: 1px solid #ccc;
      line-height: 37px;
      text-align: center;
      font-size: 14px;

      span {
        flex: 1;
        font-size: 18px;
        font-weight: 700;
      }

      .hk {
        flex: 4;
        border-right: 1px solid #ccc;
      }

      .cb {
        flex: 4;
      }

      ul {
        display: flex;
        display: flex;

        :nth-child(1) {
          flex: 1.4;
        }

        :nth-last-child(1) {
          flex: 1.3;
        }

        li {
          float: left;
          flex: 1;
        }
      }
    }

    .txt {
      margin-top: 30px;
      padding-left: 100px;

      :nth-child(-n + 4) {
        color: #f3c622;
      }

      p {
        line-height: 25px;
      }

      h6 {
        color: #333;
        margin: 80px 0;
      }
    }
  }

  #ems {
    margin-top: 80px;
  }

  .head {
    position: relative;
    width: 1200px;
    text-align: center;
    height: 150px;

    img {
      width: 400px;
    }

    h3 {
      font-weight: 700;
    }
  }

  .table {
    ol:nth-of-type(even) {
      margin-bottom: 30px;
    }

    ol {
      display: flex;
      height: 70px;
      background: #f5f5f5;
      line-height: 70px;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;

      :nth-child(1) {
        background: #f3c622;
        border: 0;
        color: #fff;
      }

      li {
        float: left;
        flex: 1;
        text-align: center;
        border-right: 1px solid #eee;
        font-size: 16px;

        sup {
          background: #f5f5f5 !important;
        }
      }

      .li {
        line-height: 35px !important;
        font-weight: 700;

        s {
          background: #f5f5f5 !important;
          color: red !important;
          line-height: 35px !important;
        }

        p {
          line-height: 35px !important;
        }
      }

      .flex5 {
        flex: 5;
      }
    }

    .ol {
      height: 300px;
      margin-bottom: 0 !important;

      :nth-child(1) {
        line-height: 38px;
      }

      li {
        line-height: 300px;
      }
    }

    h5 {
      margin: 100px 0 30px;
      text-align: center;
      color: #f3c622;
    }

    .h5 {
      padding-left: 100px;
      font-weight: 700;
      margin-bottom: 80px;
    }
  }

  .txt {
    padding-left: 100px;
    margin: 50px 0;

    p {
      line-height: 28px;
      font-size: 20px;
      color: #333;
    }

    h6 {
      font-size: 18px;
      line-height: 30px;
    }
  }

  .txt1 {
    padding-left: 100px;
    margin: 80px 0;

    p {
      line-height: 25px;
    }
  }

  .border-left1 {
    height: 2px;
    background: #567bd4;
    width: 350px;
    position: absolute;
    top: 50px;
    left: 0;
  }

  .border-right1 {
    height: 2px;
    background: #567bd4;
    width: 350px;
    position: absolute;
    top: 50px;
    right: 0;
  }

  .border-left2 {
    height: 2px;
    background: #567bd4;
    width: 480px;
    position: absolute;
    top: 30px;
    left: 0;
  }

  .border-right2 {
    height: 2px;
    background: #567bd4;
    width: 480px;
    position: absolute;
    top: 30px;
    right: 0;
  }

  .bg {
    :nth-child(1) {
      margin-right: 100px;
    }

    img {
      height: 320px;
    }
  }
}
</style>